import { AxiosInstance } from 'axios';
import { createContext, PropsWithChildren, useContext } from 'react';

type ProviderProps = {
    context: AxiosInstance;
};

const httpContext = createContext<AxiosInstance>({} as AxiosInstance);

export function ProvideHttp({ children, context }: PropsWithChildren<ProviderProps>) {
    return <httpContext.Provider value={context}>{children}</httpContext.Provider>;
}

export function useHttp() {
    return useContext(httpContext);
}
